import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/graphic/file-long.svg'


const _withScopeId = n => (_pushScopeId("data-v-453eb658"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "file-wrapper" }
const _hoisted_2 = { class: "file h-58" }
const _hoisted_3 = {
  key: 0,
  class: "video-player"
}
const _hoisted_4 = {
  key: 1,
  src: _imports_0,
  alt: ""
}
const _hoisted_5 = { class: "nav" }
const _hoisted_6 = { class: "nav-buttons" }
const _hoisted_7 = { class: "nav-btn" }
const _hoisted_8 = { class: "header" }
const _hoisted_9 = { class: "header-top" }
const _hoisted_10 = { class: "header--center" }
const _hoisted_11 = { class: "header--left" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-back" }, null, -1))
const _hoisted_13 = { class: "header__title" }
const _hoisted_14 = { class: "header--right" }
const _hoisted_15 = {
  key: 0,
  class: "box-icon"
}
const _hoisted_16 = {
  key: 1,
  class: "spacer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_video_player = _resolveComponent("app-video-player")!
  const _component_app_pdf_viewer = _resolveComponent("app-pdf-viewer")!
  const _component_drive_shared_bar = _resolveComponent("drive-shared-bar")!
  const _component_app_loader = _resolveComponent("app-loader")!
  const _component_share_pop_up = _resolveComponent("share-pop-up")!
  const _component_media_settings_pop_up = _resolveComponent("media-settings-pop-up")!
  const _component_move_to_pop_up = _resolveComponent("move-to-pop-up")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.driveStore.fullscreenFile?.type === _ctx.MEDIA_TYPES.VIDEO)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_app_video_player, { url: _ctx.videoUrl }, null, 8, ["url"])
          ]))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["file-viewer", { 'file-viewer--centered': _ctx.isPDF }])
          }, [
            (_ctx.isPDF)
              ? (_openBlock(), _createBlock(_component_app_pdf_viewer, {
                  key: 0,
                  "video-url": _ctx.videoUrl
                }, null, 8, ["video-url"]))
              : (_openBlock(), _createElementBlock("img", _hoisted_4))
          ], 2))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", {
            class: "icon icon-info",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openPopUp(_ctx.BOTTOM_POPUP_TYPES.FILE_INFO_OLD)))
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$localize('app.file.view.info')), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("a", {
              class: "back-link white",
              href: "javascript:void(0);",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
            }, [
              _hoisted_12,
              _createTextVNode(" " + _toDisplayString(_ctx.$localize('app.file.view.backtext')), 1)
            ])
          ]),
          _createElementVNode("h4", _hoisted_13, _toDisplayString(_ctx.driveStore.fullscreenFile!.name), 1),
          _createElementVNode("div", _hoisted_14, [
            (!_ctx.isNetwork && _ctx.isMy)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("span", {
                    class: _normalizeClass([{ hidden: _ctx.isCase }, "icon icon-share"]),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isMediaSharePopUp = true))
                  }, null, 2),
                  _createElementVNode("span", {
                    class: "icon icon-dots",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isMediaSettingsPopUp = true))
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_16))
          ])
        ])
      ]),
      (!_ctx.isNetwork)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isMediaSharePopUp = true)),
            class: "header-bottom"
          }, [
            (!_ctx.isNetwork)
              ? (_openBlock(), _createBlock(_component_drive_shared_bar, {
                  key: 0,
                  onOnVisitChat: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close')))
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.loader)
      ? (_openBlock(), _createBlock(_component_app_loader, {
          key: 0,
          message: _ctx.loader
        }, null, 8, ["message"]))
      : _createCommentVNode("", true),
    (_ctx.isMediaSharePopUp)
      ? (_openBlock(), _createBlock(_component_share_pop_up, {
          key: 1,
          item: _ctx.driveStore.fullscreenFile!,
          "item-type": _ctx.SHARE_TYPES.FILE,
          onHide: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isMediaSharePopUp = false)),
          onSetItemShared: _ctx.setItemShared,
          onSetSharedLabels: _ctx.setSharedLabels,
          onOnShareByMessage: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('close')))
        }, null, 8, ["item", "item-type", "onSetItemShared", "onSetSharedLabels"]))
      : _createCommentVNode("", true),
    (_ctx.isMediaSettingsPopUp)
      ? (_openBlock(), _createBlock(_component_media_settings_pop_up, {
          key: 2,
          file: _ctx.driveStore.fullscreenFile!,
          type: _ctx.MEDIA_TYPES.FILES,
          onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isMediaSettingsPopUp = false)),
          onCloseMedia: _cache[9] || (_cache[9] = ($event: any) => (_ctx.driveStore.fullscreenFile = undefined)),
          onOpenMovePopUp: _ctx.openMovePopUp,
          onDeleteMedia: _ctx.deleteFile
        }, null, 8, ["file", "type", "onOpenMovePopUp", "onDeleteMedia"]))
      : _createCommentVNode("", true),
    (_ctx.isMoveToPopUp)
      ? (_openBlock(), _createBlock(_component_move_to_pop_up, {
          key: 3,
          item: _ctx.driveStore.fullscreenFile!,
          "item-type": _ctx.SHARE_TYPES.FILE,
          onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isMoveToPopUp = false)),
          onUpdateLocation: _ctx.updateLocation
        }, null, 8, ["item", "item-type", "onUpdateLocation"]))
      : _createCommentVNode("", true)
  ]))
}